import { Button, ButtonGroup, ConfirmDialog, Dropdown, Field, TextOutput } from 'Components/Core';
import { ISelectOption } from 'Components/Core/Dropdown/types';
import { ListFieldSection } from 'Components/Layout';
import { actions } from 'Data/ReduxViewModels/Admin';
import { Guid } from 'guid-typescript';
import { useState } from 'react';
import { MdRemoveCircle } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { IAgsLaboratoryRowParams } from '../types';

const AgsExportConfigurationLaboratoryRowAdmin: React.FC<IAgsLaboratoryRowParams> = ({
  laboratorySetting,
  selectOptions,
  isDefaultConfiguration,
}) => {
  const dispatch = useDispatch();

  const [configurationForLab, setConfigurationForLab] = useState<ISelectOption | null>(
    laboratorySetting?.AgsExportConfigurationUUID && {
      value: laboratorySetting.AgsExportConfigurationUUID.toString(),
      label: laboratorySetting.AgsExportConfigurationName,
    }
  );

  const dropDownOnChange = (evt: any) => {
    var selectedOption = evt.data.value;
    setConfigurationForLab(selectedOption && { value: selectedOption.value, label: selectedOption.label });

    if (isDefaultConfiguration) {
      dispatch(actions.setAgsDefaultConfigurationMapping({ configurtionId: selectedOption?.value }));
    } else {
      dispatch(actions.setAgsLaboratoryMapping({ labId: evt.data.name, configurtionId: selectedOption?.value }));
    }
  };

  const removeMapping = (labId: Guid) => {
    dispatch(actions.deleteAgsDefaultConfigurationMapping({ labId: labId }));
  };

  return (
    <ListFieldSection withAction>
      <Field
        input={<TextOutput />}
        fieldAdditionalClassName={'Field-Center-Vertical'}
        value={laboratorySetting.LaboratoryName}
      />
      <Field
        input={<Dropdown />}
        fieldAdditionalClassName={'Field-Center-Vertical'}
        name={laboratorySetting.LaboratoryUUID.toString()}
        value={configurationForLab}
        onChange={dropDownOnChange}
        options={selectOptions}
        isClearable={false}
      />
      <ButtonGroup align="right">
        <ConfirmDialog
          confirmTitle="Removing Laboratory Mapping"
          confirmText="Are you sure you want to remove this Mapping?"
        >
          <Button
            subtle
            error
            visible={!isDefaultConfiguration}
            onClick={() => removeMapping(laboratorySetting.LaboratoryUUID)}
          >
            <MdRemoveCircle size="2em" />
          </Button>
        </ConfirmDialog>
      </ButtonGroup>
    </ListFieldSection>
  );
};

export default AgsExportConfigurationLaboratoryRowAdmin;
